import { Component, OnInit, ViewChild, Input } from '@angular/core';
import {DoctorService} from '../../services/doctor.service';
import {Serviceprovider} from '../../classes/serviceprovider.interface';
import { Leavedays} from '../../classes/leavedays.interface';
import {Shedule} from '../../classes/availableshedule.interface';
import {Appointment} from '../../classes/appointment.interface';
import {Pet} from '../../classes/pet.interface';
import {ActivatedRoute, Router, Params } from '@angular/router';

import {MatSnackBar} from '@angular/material';
import {MatDialog,MatDialogRef} from '@angular/material';
import { RazorpayService } from '../../PaymentGateway/razorpay/razorpay.service';
import {DatePipe} from '@angular/common'
import {
  DomSanitizer
} from '@angular/platform-browser';

import {
  MatIconRegistry
} from '@angular/material';
/*
import {
  StepperOptions,
   NgxStepperComponent
} from '../../../ngx-stepper';
*/
import { MatStepper } from '@angular/material';
import * as moment from 'moment';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { AddnewpetComponent } from '../../pulse/addnewpet/addnewpet.component';
import {MatRadioChange } from '@angular/material';
@Component({
  selector: 'app-bookingappointment',
  templateUrl: './bookingappointment.component.html',
  styleUrls: ['./bookingappointment.component.css']
})

export class BookingappointmentComponent implements OnInit {
  step: any;
  razoid: any;
  basiconsid: any;
  clid: any;
  clinic: any;
  num: any;
  data: any;
  temparr = [];
  inleave: number;
  amt: any;
  amount: number;
  tempdata: number;
  ipadd: any;
  source: any;
  otp: number;
  vflag: number;
  @ViewChild('stepperDemo')
 // public steppers: NgxStepperComponent;
user: any;
 /* public options: StepperOptions = {
    vertical: false,
    linear: true,
    alternative: true,
    mobileStepText: false,
    enableSvgIcon: true
  };*/
  public campaign = false;
  action: any;
  second: any;
  minute: any;
  hour: any;
 mypetList: any;
 selectedpetid: any;
 rofapp: any;
 servicemenu = [];
 servicedetail = [];
  t: any;
  apptimeset: number;
  msg: string;
  flag: number ;
  len: number;
  time = [];
  app: Appointment[];
  updatepetindb: number;
  umobile: any;
  userid: any;
  todaysdate: any;
  showslot: number;
  confirmationstatus: number;
  spstatus: number;
  selectedpmode: any;
  formdatastatus: number;
  formdataname: any;
  formdatatype: any;
  formModal: any;
  result = [];
  confirmmodal:any;
  leavestatus: number;
  public datepicker = {
    month: '',
  }
  check: number;
  openshedule: number;
  pid:number;
  leave: Leavedays[];
  shedule: any;
  selectedslot: any;
  formdata:any = {};
  appointment: any;
  loading:any;
  start:any;
  petdata: Pet;
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  constructor(private doctorService: DoctorService, private route: ActivatedRoute,
    public snackBar: MatSnackBar, public dialog: MatDialog, private router: Router,
     private _sanitizer: DomSanitizer,private commonService: CommonService,
     private razorpayService: RazorpayService) {
      this.check = 0;
      this.data = 0;
      this.num = [];
      this.route.params.subscribe(params => {
        const id = +params['id'];
        this.pid = id;
         });
         this.loading = false;
         this.openshedule = 0;
         const dat = this.getDate();
         this.todaysdate = dat;
         this.datepicker.month  = dat;
         this.leavestatus = 0;
         this.formdatastatus = 0;
         this.confirmationstatus = 0;
         this.spstatus = 0;
         this.updatepetindb = 0;
         this.apptimeset = 0;
         const udata = this.commonService.getUserDataLocally();
         this.userid = udata.uid;
         this.umobile = udata.umobile;
         this.razorpayService.paymentstatus.subscribe(ps => {
          if (ps === 1) {
            this.nextAction();
          } else if(ps === 2) {
            this.msg = 'Payment is cancelled or your payment session is over';
            this.openSnackBar();
            this.razorpayService.managestatus.next(0);
            window.history.back();
          } 
        });
        this.commonService.getIpAddress()
        .subscribe(
          (x) => {
            this.ipadd = x.ip;
          });
          this.source = 'WebApp';
          
         
         
   }

  ngOnInit() {
    // this.checkleaves();
    this.getdoctorAppointments(this.datepicker.month);
    this.getuserPet();
    this.getDoctorServices();
    this.getParticularUser();
    this.getService();


  }

  getService() {
    this.doctorService.getBasicConsultation()
    .subscribe((x) => {
      this.getServicemenus(x[0].id);
    });
  }

  getServicemenus(id) {
    this.doctorService.getFees(id, this.pid)
    .subscribe((x) => {
      this.basiconsid = x[0].fees;
    });
  }
 
  getParticularUser() {
    this.loading = true;
    this.commonService.getParticularUser(this.userid)
    .subscribe(
      (x) => {
        this.loading = false;
        if (x[0].verified === 'v') {
          this.vflag = 1;
        } else {
          this.vflag = 0;
        }
        this.user = x;

      });

  }
  getDate(){
    var today = new Date();
    var d:string;
    var m: string;
    var dd = today.getDate();
    var mm = today.getMonth()+1; //January is 0!
    var yyyy = today.getFullYear();
    var da:any;
   
  
    if(dd<10) {
      d = '0'+dd;
    } 
    else
      d= dd.toString();
  
    if(mm<10) {
      m = '0'+mm
    } 
    else
      m = mm.toString();
  
  
    da = yyyy + '-' + m + '-' + d
    return da.toString();
  }

  getTime(second){
   
    var today= new Date();
    this.hour= today.getHours();
    this.minute= today.getMinutes();
    this.second= today.getSeconds();
    var sec = (+this.hour) * 60 * 60 + (+this.minute) * 60 ;
  
    if(sec>second){
      this.msg = 'invalid selection';
      this.openSnackBar();
    }
    else {
      this.insertTime(second);
   }
    
  }
  pastTime(second){
    var hms= second;
    var a = hms.split(":");
    var ss = (+a[0]) * 60 * 60 + (+a[1]) * 60;
     var today= new Date();
     this.hour= today.getHours();
     this.minute= today.getMinutes();
     this.second= today.getSeconds();
     var sec = (+this.hour) * 60 * 60 + (+this.minute) * 60;

     if(sec>ss && this.todaysdate == this.datepicker.month){
      // this.msg = 'invalid selection';
      // this.presentToast(this.msg);
      return true;
     }
   }

  getShedule(){
    this.result=[];
   // this.checkleaves();
    
  }
  
  getdayname(){
    var weekday = new Array(7);
    weekday[0] =  "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    
   var d = new Date(this.datepicker.month);
     var n = weekday[d.getDay()];
    
     return n;
  }
  getavailableShedule(){
    this.loading = true;
    this.shedule = [];
    this.inleave = 0;
    this.result = [];
    var day = this.getdayname();
    this.doctorService.getdoctorScheduleByDate(this.pid,this.datepicker.month)
    .subscribe((shedule) => {
        this.shedule = shedule;
        if(this.shedule && this.shedule.length > 0){
          this.check = 0;
        } else {
          this.check = 1;
        }
        for (let i = 0; i < this.shedule.length - 1; i++)  {
          // Last i elements are already in place
          for (let j = 0; j < this.shedule.length - i - 1; j++) {
            if (this.shedule[j].start_time > this.shedule[j + 1].start_time) {
              var temp = this.shedule[j];
              this.shedule[j] = this.shedule[j + 1];
              this.shedule[j + 1] = temp;
            }
           }
          }
        this.loading = false;
        this.getClinic();
        if(this.shedule.length > 0){
          for(let i=0;i<this.shedule.length;i++){
            this.timeArray(this.shedule[i].start_time,this.shedule[i].end_time,this.shedule[i].slotduration,this.shedule[i].clinic_id)
          }
        }
      },(err) => {

          this.shedule.push({'body':err._body});
            this.inleave = 1;
          this.loading = false;
        }); 
  }

  getClinic() {
    this.doctorService.getClinic()
    .subscribe((x) => {
      this.clinic = x;
    });

  }

  getdoctorAppointments(datepicker){
    console.log('here in get doctor');
    this.loading = true;
    this.doctorService.getdoctorAppointment(this.pid,datepicker)
    .subscribe(
      (x: Appointment[])=>{
        this.loading = false;
        this.app= x; 
       // this.checkleaves();
       this.getavailableShedule();
           this.convertimes();   
          });
  }
  convertimes() {
    this.time = [];
    for(let i = 0; i < this.app.length ;  i++){
      var hmss= this.app[i].start_time;
      var b = hmss.split(":");
      var sec = (+b[0]) * 60 * 60 + (+b[1]) * 60 ;
      this.time.push({'name':sec}) ;
      }
      this.apptimeset = 1
  }
  isAlreadySelected(time){ 
    var hms= time;
    var a = hms.split(":");
    var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 ;
      for(let j=0; j < this.time.length; j++){   
        if(seconds === this.time[j].name){  
            return true;                           
        } 
  }

}

selectedTime(stime, clid){
  this.clid = clid;
  this.flag=0;
  this.t = stime;
  var hms= stime;
  var a = hms.split(":");
  var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 ;
for(let i = 0; i < this.time.length; i++) {
  if( this.time[i].name == seconds){
    this.flag = 1; 
    this.flag = this.flag + 1;
  }
}
if(this.todaysdate == this.datepicker.month){
this.getTime(seconds);
} else{
this.insertTime(seconds); 
}
}
insertTime(seconds) {
  if( this.flag > 0){
  this.msg = 'Already Booked';
 this.openSnackBar();
  } else {
    this.selectedslot = this.t;
  }
}
  /*checkleaves(){
    this.leavestatus = 1;
    this.loading = true;
    this.doctorService.checkLeave(this.pid,this.datepicker.month)
    .subscribe(
      (leave:Leavedays[])=>{
        this.leave=leave;
        this.loading = false;
        if(this.leave.length > 0){
          this.leavestatus= 0;
        }  else {
          this.leavestatus = 1;
          this.checkLeavestatus();
        }
      });
  }
  checkLeavestatus(){
    if(this.leavestatus==1){
      this.getavailableShedule();
    } else {
      this.result = [];
  }
  } */
   timeArray(start, end,slot,clinicid) {
    this.data = this.data + 1;
    this.num.push({"id":this.data,"clinicid": clinicid});
     this.result= [];
    var start = start.split(":");
    var end = end.split(":");
    slot=slot * 60;
    var resultid= 0;
    start = parseInt(start[0]) * 3600 + parseInt(start[1]) * 60 ;
    end = parseInt(end[0]) * 3600 + parseInt(end[1]) *60 ;

    for ( let time = start; time < end; time+=slot){
        resultid = resultid + 1;
     
       this.result.push({"id":resultid,"name": this.timeString(time)});
    }
    for(let k = 0; k < this.result.length; k++){

      this.temparr.push({"id": this.data, "val": this.result[k].name})  ;
    }
    this.len = this.result.length;
	
    if(this.result && this.result.length==0)
    {
      this.msg = 'doctor is in leave for the day';
      this.openSnackBar();
    }
    else 
      this.showslot=1;
      //this.getdoctorAppointments(this.datepicker);
    
}

 timeString(time) {
    var hours = Math.floor(time / 3600);
    var temp = time % 3600
    var minutes = Math.floor(temp / 60);
    var second = temp % 60;
    if (hours < 10){
      hours = 0 + hours;
  } if(minutes < 10){
    return hours + ":" + 0 + '' + minutes ;
  } else { 
    return hours + ":" + minutes ;
  }//optional
      
  //  if (minutes < 10) minutes =  minutes;
}
choose(name ){
  this.selectedslot=name;
  this.showslot=0;
}

gotoFormstep() {
  const dialogRef = this.dialog.open(AddnewpetComponent ,{
    width: '400px',
    height: '400px',
    data: {spid: this.pid}
  });
dialogRef.afterClosed().subscribe(result => {
  if(result) {
    this.formdata = result;
    this.rofapp = this.formdata.reason;
    this.formdataname = this.formdata.name;
    this.formdatatype = this.formdata.type;
    this.formdatastatus=1;
    this.adduserpet();
  }else {
    this.formdatastatus=0;
  }
});
}
adduserpet() {
  var petimage: any;
  var bio= 'about me';
  if(this.formdata.type === 'dog') {
    petimage = 'dogavatar.png';
  }
  if(this.formdata.type === 'cat') {
    petimage = 'catavatar.png';
  }
  if(this.formdata.type === 'Birds') {
    petimage = 'dogavatar.png';
  }
  if(this.formdata.type === 'Rabbit/Hamsters') {
    petimage = 'catavatar.png';
  }
  if(this.formdata.type === 'Others') {
    petimage = 'dogavatar.png';
  }
  this.loading = true;
  this.doctorService.createuserPetDetail(this.userid,this.formdata.name,this.formdata.type ,this.formdata.dob,petimage,bio)
  .subscribe(
    (x)=> {
      this.selectedpetid = x.id;
     this.loading = false;
    });
}


bookAppointment(stepper: MatStepper) {
  this.step = stepper;
  let status = 'Booked';
  this.selectedpmode = 'razorpay';
 if (this.selectedpmode === 'razorpay') {
   status = 'Pending';
 }
  const pstatus = 'pending';
  const endtime = this.calculateEndtime(this.selectedslot,this.shedule[0].slotduration);
  this.loading = true;
  if (this.ipadd === undefined) {
    this.ipadd = '0.0.0.0' ;
  }
 this.doctorService.bookingAppointment(this.pid,this.userid,this.datepicker.month,this.selectedslot,
endtime,status,this.rofapp,this.selectedpetid, pstatus, this.selectedpmode , this.clid, this.ipadd, this.source)
.subscribe(
  (x)=> {
    this.loading =false;
    this.appointment = x;
    var app = 'PC-APPOINTMENT';
    if( x.id < 10) {
      this.razoid = app +'00000'+  x.id;
    } else if(x.id < 100) {
      this.razoid = app +'0000'+  x.id;
    } else if(x.id < 1000) {
      this.razoid = app +'000'+  x.id;
    } else if(x.id < 10000) {
      this.razoid = app +'00'+  x.id;
    } else if(x.id < 100000) {
      this.razoid = app +'0'+  x.id;
    } else if(x.id < 1000000) {
      this.razoid = app + x.id;
    }
   if (this.selectedpmode === 'razorpay') {
     this.openRazorpay();
   } else {
    this.msg = 'Booking Successful';
    this.openSnackBar();
     this.selectCampaign();
   }
   },err =>{
    this.loading = false;
    this.msg = 'Can not book now. Select a slot which is 1 hour from the current time.';
    this.openSnackBar();
   });
}
getdoctorAppointmentsPage(){
  //this.navCtrl.setRoot("AppointmentPage");
}
calculateEndtime(start,interval){
  var start = start.split(":"); 
  interval=interval * 60;
  start = parseInt(start[0]) * 3600 + parseInt(start[1]) * 60  ;
  var end = start+interval;
   end= this.timeString(end);
   return end;
}
myselectedSelected(data){
  if(data == this.selectedslot){
    return true;
  }
}
GetOtherTimeSlot(){
  this.selectedslot = undefined;
 // this.checkleaves();
 this.data = 0;
 this.num = [];
 this.temparr = [];
  this.getdoctorAppointments(this.datepicker.month);
}
getuserPet(){
  this.loading = true;
  this.doctorService.getUserPetInfo(this.userid)
  .subscribe(
    (x)=>{
      this.mypetList = x;
      this.loading = false;
    }
  );
}
getDoctorServices(){
  this.loading = true;
  this.doctorService.getServiceMenu(this.pid)
  .subscribe(
    (x) => {
      this.servicemenu = x;
      this.loading = false;
      for(let i = 0 ;i< this.servicemenu.length ; i++){
        this.getServiceDetail(this.servicemenu[i].service_id)
      }
    });
}
getServiceDetail(service_id) {
this.doctorService.getAllServices(service_id)
.subscribe(
  (x) => {

    if(x[0].name !== 'Text Chat' && x[0].name !== 'Video Chat'){
      this.servicedetail.push(x[0]);
       }

  });
}
verifyMobile(stepper: MatStepper) {
  this.loading = true;
  this.otp = this.getRandomArbitrary(1000, 9000);
  this.commonService.createOtp(this.userid, this.otp)
  .subscribe(
     (x) => {
       this.loading = false;
     this.commonService.sendOtp(this.user[0].name, this.umobile, this.otp);
     stepper.selectedIndex = 2;
     // this.steppers.next();
    }
  );
}
postForOtp(stepper) {
    if (this.otp == this.tempdata) {
        this.verifiedUser(stepper);
      } else {
        this.msg = 'enter Correct Otp';
        this.openSnackBar();
      }

}
verifiedUser(stepper: MatStepper) {
  this.loading = true;
  this.commonService.verifyuser(this.userid)
  .subscribe(
    (x) => {
      this.loading = false;
      this.msg = 'Verification Successful';
      this.openSnackBar();
      stepper.selectedIndex = 3;
     // this.steppers.next();
    });
}

getRandomArbitrary(min, max) {
  const num = min + Math.random() * max;
 return Math.trunc(num);
}
public selectCampaign(): void {
//  this.steppers.showFeedback('Checking, please wait ...');
  setTimeout(() => {
   // this.steppers.clearError();
     // this.steppers.next();
  }, 2000);
}
/*
public previousStep(): void {
//  this.steppers.back();
}

public cancel(): void {
 // this.steppers.back();
}

public nextStep(): void {
 // this.steppers.next();
}

public toggleMobileStepText(): void {
  this.options.mobileStepText = !this.options.mobileStepText;
  this.options = Object.assign({}, this.options);
}

public toggleLinear(): void {
  this.options.linear = !this.options.linear;
  this.options = Object.assign({}, this.options);
}

public toggleAlternative(): void {
  this.options.alternative = !this.options.alternative;
  this.options = Object.assign({}, this.options);
}

public toggleVertical(): void {
  this.options.vertical = !this.options.vertical;
  this.options = Object.assign({}, this.options);
}

public showError(): void {
  this.steppers.error('Wrong campaign');
}

public clearError(): void {
  this.steppers.clearError();
}

public showFeedback(): void {
  this.steppers.showFeedback('Step 1 looks great! Step 2 is comming up.');
}

public clearFeedback(): void {
  this.steppers.clearFeedback();
}
*/
openSnackBar() {
  this.snackBar.open(this.msg , this.action, {
    duration: 4000,
  });
}
openRazorpay() {
 // this.amount = this.getFees();
  this.amount = this.basiconsid;
  var type = 'docapp';
  this.razorpayService.createtransaction(this.user[0].name, this.user[0].email, this.umobile, this.amount, this.razoid, type)
}
getFees() {
  for (let i = 0 ; i < this.servicemenu.length; i++) {
    if (this.servicemenu[i].service_id == this.rofapp) {
      var amt = this.servicemenu[i].fees;
      if(amt == 0) {
        amt = this.basiconsid;
      } else {

      }
      return amt;
    }
  }
}

getAmount() {
  for (let i = 0 ; i < this.servicemenu.length; i++) {
    if (this.servicemenu[i].service_id == this.rofapp) {
      this.amt = this.servicemenu[i].fees;
      if(this.amt == 0) {
        this.amt = this.basiconsid;
      } else {
      }
    }
  }
}
private nextAction() {
  const paymentid = this.razorpayService.getPaymentId();
  this.loading = true;
  if( paymentid !== undefined){
  const order_id = this.appointment.id;
  const order_type = 'appointment';
  this.razorpayService.initiateTransaction(this.userid, paymentid, this.amount, order_id ,
  order_type)
  .subscribe(
    (x) => {
      this.loading = false;
      this.updatePaymentStatus();
    });
  } else {
    this.loading = false;
    this.razorpayService.managestatus.next(0);
    this.msg = 'Booking Successful';
    this.openSnackBar();
    if(this.user && this.user.length>0 && this.vflag===0){
      this.step.selectedindex = 4;
    } else {
      this.step.selectedindex = 3;
    }
   // this.steppers.next();
  }
}
updatePaymentStatus() {
  this.loading = true;
  const stat = 'Complete';
  const status = 'Booked';
  this.doctorService.updateAppointmentPayment(this.appointment.id, stat, status)
    .subscribe(
      (x) => {
        this.loading = false;
        this.razorpayService.managestatus.next(0);
        this.msg = 'Booking Successful';
        this.openSnackBar();
        if(this.user && this.user.length>0 && this.vflag===0){
          this.step.selectedindex = 4;
        } else {
          this.step.selectedindex = 3;
        }
       // this.steppers.next();
      });
}
 scrollWin() {
  window.scrollTo(0, 0);
}

nextStep1(stepper: MatStepper) {
  stepper.selectedIndex = 1;
}

nextStep2(stepper: MatStepper) {
  stepper.selectedIndex = 2;
}


back1(stepper: MatStepper) {
  stepper.selectedIndex = 0;
}

back2(stepper: MatStepper) {
  stepper.selectedIndex = 1;
}


nvnextStep1(stepper: MatStepper) {
  stepper.selectedIndex = 1;
}



nvback1(stepper: MatStepper) {
  stepper.selectedIndex = 0;
}

nvback2(stepper: MatStepper) {
  stepper.selectedIndex = 1;
}


}


